export const homeEn = {
  // Hero section
  heroTitle: "She Can. She Will. She Did.",
  heroSubtitle: "A movement born from resilience, built for every woman who has ever been told 'you can't.'",
  heroButton: "Join Our Community",
  
  // Story section
  storyTitle: "Real Women, Real Transformations",
  storyText1: "These aren't celebrity success stories—they're the women in my life who showed me what courage looks like. My aunt who left everything to start over. My mother who fought for her education when everyone said it was too late.",
  storyText2: "Every woman here has a story of breaking barriers, defying expectations, and proving that transformation is possible at any age, from any starting point.",
  storyButton: "Read Our Stories",
  
  // Community section
  communityTitle: "Join a Community of Unstoppable Women",
  communitySubtitle: "Connect, grow, and thrive together",
  communityFeature1: "Supportive Network",
  communityFeature1Text: "Connect with like-minded women who understand your journey",
  communityFeature2: "Exclusive Events",
  communityFeature2Text: "Access workshops, webinars, and networking opportunities",
  communityFeature3: "Resources & Tools",
  communityFeature3Text: "Get practical resources to help you achieve your goals",
  communityButton: "Explore Community",
  
  // Featured Products
  productsTitle: "Empower Your Journey",
  productsSubtitle: "Curated products to inspire and support you",
  
  // Testimonials
  testimonialsTitle: "Women Who Proved Everyone Wrong",
  testimonial1: "My aunt left an abusive marriage at 45 with nothing. Today, at 52, she owns her own café and employs three other women starting over. She taught me that it's never too late to choose yourself.",
  testimonial1Author: "Fatma's Story",
  testimonial1Role: "My Aunt - From Survivor to Business Owner",
  testimonial2: "My mother went back to university at 38 while raising three kids. Everyone said she was crazy. She graduated top of her class at 42 and now mentors young women in STEM. She taught me that your dreams don't expire.",
  testimonial2Author: "Ayşe's Story",
  testimonial2Role: "My Mother - From Homemaker to Engineer",
  testimonial3: "My neighbor escaped war with two children and $200. She didn't speak the language, didn't have a degree recognized here. Five years later, she's a certified nurse saving lives. She taught me that your past doesn't define your future.",
  testimonial3Author: "Mariam's Story",
  testimonial3Role: "My Neighbor - From Refugee to Healthcare Hero"
};

export default homeEn;
